module.exports = __webpack_public_path__ + "static/media/child_on.82d7cd76.png";